import { render, staticRenderFns } from "./SearchBarResultItem.vue?vue&type=template&id=1425239a&scoped=true"
import script from "./SearchBarResultItem.vue?vue&type=script&lang=js"
export * from "./SearchBarResultItem.vue?vue&type=script&lang=js"
import style0 from "./SearchBarResultItem.vue?vue&type=style&index=0&id=1425239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425239a",
  null
  
)

export default component.exports